import lz from 'lz-string';
import config from '@clubmed/config-util';

const data = window.appConfig;

// Remove script from the DOM
const nodes = document.querySelectorAll('script');
for (let i = 0; i < nodes.length; i++) {
  if (nodes[i].innerText && nodes[i].innerText.indexOf('window.appConfig = ') !== -1) {
    nodes[i].parentNode.removeChild(nodes[i]);
    break;
  }
}

// Remove data from the global object
delete window.appConfig;

const appConfig = config(data ? JSON.parse(lz.decompressFromEncodedURIComponent(data)) : {});
appConfig.set(
  'graphql.host',
  appConfig.get('proxy.activate')
    ? appConfig.get('proxy.contextPath')
    : appConfig.get('graphql.clientHost'),
);

export default appConfig;
